import React from 'react';
import BuilderLogo from './BuilderLogo';

const BuilderSelector = ({ builders, selectedBuilder, onBuilderSelect }) => {
    return (
        <div className="w-full flex justify-center">
            <div className="flex overflow-x-auto no-scrollbar pb-6 md:pb-12 md:px-8 gap-6 md:gap-16 snap-x snap-mandatory mx-auto max-w-full md:justify-center after:content-[''] before:content-['']">
                {Object.entries(builders).map(([builderId, builderHomes]) => {
                    // Use the first home's data for the builder logo
                    const builder = builderHomes[0];

                    return (
                        <BuilderLogo
                            key={builderId}
                            logo={builder.logo}
                            alt={builder.name}
                            isSelected={selectedBuilder === builderId}
                            onClick={() => onBuilderSelect(builderId)}
                            className="snap-center flex-shrink-0"
                        />
                    );
                })}
            </div>
        </div>
    );
};

export default BuilderSelector;